import { Filter } from 'src/app/modules/core/store/models/filters.model';
import { IFieldFilterHandler, FieldFilterHandler } from 'src/app/modules/core/services/filter-runtime/field-handlers';

export class DistanceFieldFilterHandler extends FieldFilterHandler implements IFieldFilterHandler {
  constructor() {
    super();
  }

  fieldMatchesFilter(value: any, filter: Filter): boolean {
    const handler = this.comparisonHandlers[filter.operator];
    if (!handler) {
      return true;
    }

    const floatValue = parseFloat(value);

    const floatFilter = {
      ...filter,
      value: parseFloat(filter.value)
    };

    const doesMatch = handler(floatValue, floatFilter);

    return doesMatch;
  }
}
